<i
    [ngClass]="class"
    [pTooltip]="tooltipKey ? (tooltipKey | tooltip | async)! : ''"
    tooltipPosition="top"
    placeholder="top"
    [escape]="false"></i>
